module.exports = __webpack_public_path__ + "static/media/test17_2.841ee920.png";